import truncate from 'lodash/truncate';

import styles from './Styles.style';

function KeyValueRow(props) {
  const { classes, label, link, value } = props;

  let truncValue = typeof value === 'string' ? truncate(value, 200) : value;

  return (
    <div className={classes.row}>
      <div className={classes.key}>{label}</div>
      <div className={classes.value} title={value}>
        {link ? (
          <a href={link} rel="noopener noreferrer" target="_blank">
            {truncValue}
          </a>
        ) : (
          truncValue
        )}
      </div>
    </div>
  );
}

export default withStyles(styles)(KeyValueRow);
